module.exports = __webpack_public_path__ + "media/theme/time zone-72fe32ed.svg";